<template>
  <div>
    <Head @langChange="langSelect" />
    <section
      class="gameTop TopWarp"
      :style="{
        'background-color': '' + TopBgColor + '',
      }"
    >
      <img :src="TopUrl" alt="" />
      <div class="cont">
        <p class="p1" v-if="TopTitle != ''">{{ TopTitle }}</p>
        <p v-if="TopContent != ''">{{ TopContent }}</p>
      </div>
    </section>
    <section class="PrivacyWarp cl">
      <div class="cl title">
        <div
          class="item"
          v-for="(item, index) in TitList"
          :class="[
            active == index ? 'on' : '',
            TitList.length == 1 ? 'os' : '',
          ]"
          @click="tabEvn(index)"
          :key="index"
        >
          {{ item.text }}
        </div>
      </div>
      <div class="content cl editorWarp">
        <div
          class="item"
          v-for="(item, index) in contList"
          :class="[active == index ? 'on' : '']"
          :key="index"
        >
          <div class="editorWarp" v-html="item.content"></div>
        </div>
      </div>
    </section>
    <!-- 底部footer -->
    <Foot ref="foot"></Foot>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Head from "@/components/head.vue";
import Foot from "@/components/Foot.vue";
import { getCommonPage } from "@/common/api.js";
// 隐私政策
export default {
  name: "Privacy",
  components: {
    Head,
    Foot,
    getCommonPage,
  },
  data() {
    return {
      TopUrl: "",
      TopBgColor: "",
      TopTitle: "",
      TopContent: "",
      active: 0,
      TitList: [],
      contList: [],
      lang: this.$route.query.language || "zh",
    };
  },
  created() {
    this.getCommon();
  },
  mounted() {},
  methods: {
    getCommon() {
      let that = this;
      getCommonPage({
        type: "privacy",
        language: that.lang,
      }).then((res) => {
        if (res.status == 200) {
          let Data = res.data.data;
          that.TopUrl = Data.TopUrl;
          that.TopBgColor = Data.TopBgColor;
          that.TopTitle = Data.TopTitle;
          that.TopContent = Data.TopContent;
          that.TitList = Data.TitList;
          that.contList = Data.contList;
        } else {
          console.log(res.statusText);
        }
      });
    },
    langSelect: function (param) {
      this.lang = param;
      this.getCommon();
      this.$refs.foot.langSelect(param);
    },
    tabEvn(index) {
      this.active = index;
    },
  },
  computed: {
    // ...mapState({
    //   lang: (state) => state.lang,
    // }),
  },
};
</script>

<style scoped>
</style>







// WEBPACK FOOTER //
// src/views/Privacy.vue